import { zeropad2 } from '@square/dashboard-data/utils/zero-pad';
import moment from 'moment-timezone';
import Transform from '@ember-data/serializer/transform';
const delimiter = ':';
export default class TimeOfDay extends Transform {
  deserialize(timeOfDayText) {
    if (!timeOfDayText) {
      return null;
    }
    const time = moment(timeOfDayText, `HH${delimiter}mm`);
    return {
      hour: time.hour(),
      minute: time.minute()
    };
  }
  serialize(timeOfDay) {
    if (!timeOfDay) {
      return null;
    }
    const {
      hour,
      minute
    } = timeOfDay;
    return `${zeropad2(hour)}${delimiter}${zeropad2(minute)}`;
  }
  static toMoment(timeOfDay, timeZone) {
    if (!timeZone) {
      throw new Error('Missing timezone for conversion');
    }
    const hour = timeOfDay.hour;
    const minute = timeOfDay.minute;
    return moment().tz(timeZone).hour(hour).minute(minute).startOf('minute');
  }
  static formatted(localeTime, timeOfDay, timeZone) {
    const date = this.toMoment(timeOfDay, timeZone).toDate();
    return localeTime.dateTime(date, 'shortTime');
  }
  static midnight() {
    return {
      hour: 0,
      minute: 0
    };
  }
}